// extracted by mini-css-extract-plugin
export default {"inputContainer":"inputBox_inputContainer__W6lK0","error":"inputBox_error__ED8ku"};